var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, PureComponent } from 'react';
import Timebar from './Timebar/Timebar';
var noop = function () { };
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.handleScroll = function () {
            var sticky = _this.props.sticky;
            var targetScrollY = _this.scroll.current ? _this.scroll.current.scrollLeft : 0;
            sticky.handleHeaderScrollY(targetScrollY);
        };
        _this.scroll = createRef();
        _this.timebar = createRef();
        return _this;
    }
    Header.prototype.componentDidrender = function () {
        var sticky = this.props.sticky;
        if (sticky) {
            var currentOffsetHeight = this.timebar.current ? this.timebar.current.offsetHeight : 0;
            sticky.setHeaderHeight(currentOffsetHeight);
            var scrollLeft = sticky.scrollLeft, isSticky = sticky.isSticky;
            if (isSticky) {
                if (this.scroll.current) {
                    this.scroll.current.scrollLeft = scrollLeft;
                }
            }
        }
    };
    Header.prototype.componentDidUpdate = function (prevProps) {
        var sticky = this.props.sticky;
        if (sticky) {
            var scrollLeft = sticky.scrollLeft, isSticky = sticky.isSticky;
            var prevScrollLeft = prevProps.sticky.scrollLeft;
            var prevIsSticky = prevProps.sticky.isSticky;
            if (scrollLeft !== prevScrollLeft || isSticky !== prevIsSticky) {
                if (this.scroll.current) {
                    this.scroll.current.scrollLeft = scrollLeft;
                }
            }
        }
    };
    Header.prototype.render = function () {
        var _a = this.props, time = _a.time, onMove = _a.onMove, onEnter = _a.onEnter, onLeave = _a.onLeave, width = _a.width, rows = _a.timebar, sticky = _a.sticky;
        var isSticky = sticky.isSticky, headerHeight = sticky.headerHeight, viewportWidth = sticky.viewportWidth;
        return (_jsx("div", __assign({ style: isSticky ? { paddingTop: headerHeight } : {}, onMouseMove: onMove, onMouseEnter: onEnter, onMouseLeave: onLeave }, { children: _jsx("div", __assign({ className: "rt-timeline__header ".concat(isSticky ? 'rt-is-sticky' : ''), style: isSticky ? { width: viewportWidth, height: headerHeight } : {} }, { children: _jsx("div", __assign({ className: "rt-timeline__header-scroll", ref: this.scroll, onScroll: isSticky ? this.handleScroll : noop }, { children: _jsx("div", __assign({ ref: this.timebar, style: isSticky ? { width: width } : {} }, { children: _jsx(Timebar, { time: time, rows: rows }) })) })) })) })));
    };
    return Header;
}(PureComponent));
export default Header;
